export const ASSET_IMAGES = process.env.PUBLIC_URL + "/images";
export const ASSET_AVATARS = ASSET_IMAGES + "/avatar";
export const ASSET_LOGOS = ASSET_IMAGES + "/logos";
export const ASSET_SAMPLE_FILES = process.env.PUBLIC_URL + "/samplefiles";
export const USE_IMAGE_PLACEHOLDERS = false;

//API END POINTS
export const baseUrl = "https://consent-uiapi.advangelists.com"; //"http://localhost:3002"  // https://consent-uiapi.advangelists.com
export const getDataEndPoint = baseUrl + "/direct/getdata";
export const updateDataEndPoint = baseUrl + "/direct/updatedata";
export const insertDataEndPoint = baseUrl + "/direct/insertdata";
export const loggedInUserDetailsEndPoint = baseUrl + "/admin/authuserinfo";
export const switchUserEndPoint = baseUrl + "/auth/switchuser";
export const createUpdateDomainIABEndpoint =
  baseUrl + "/admin/insertUpdateDomainIAB";
export const getReportingDataEndPoint = baseUrl + "/report/getdata/";
export const getTGroupDataEndPoint = baseUrl + "/admin/gettgid/";
export const getAllCampaignsListApiUrl = baseUrl + "/admin/getcampaigns";
export const updateAccountPaymentsUrl =
  baseUrl + "/admin/updateaccountspayments";
export const getEntityHistoryApiUrl = baseUrl + "/admin/getEntityDetails";

export const getStripePaymentPublisherKeyUrl =
  baseUrl + "/misc/getStripePublisherKey";
export const stripePaymentIntentUrl = baseUrl + "/misc/stripePaymentIntent";
export const stripeRefundUrl = baseUrl + "/misc/stripeRefund";

export const getDeliveryReportingDataEndPoint =
  baseUrl + "/report/getDeliveryReportData";

export const getRegionIDReportingDataEndPoint =
  baseUrl + "/report/getCampaignReportDataByRegionId";

export const mobiquityMNPixelsTable = "prod_replica.mobiexchange.mn_pixels";

export const eventHourlyReportingTable =
  "neptune.neptune.events_hourly_reporting_test";

export const attibutionHourlyReportingTable =
  "neptune.neptune.campaign_attribution";

export const dataStoreRealTimeTable =
  "neptune.neptune.data_store_real_time_test";

export const getPublisherPreloadDataEndPoint =
  baseUrl + "/admin/getpublisherdata";

export const sendEmailOnPublisherCreationDataEndPoint =
  baseUrl + "/misc/sendEmailOnPublisherCreation";

export const getCampaignIdsDownloadEndPoint =
  baseUrl + "/misc/getCampaignIdsDownloadUrl";
export const downloadAudiencePixelDetailedReportEndPoint =
  baseUrl + "/misc/downloadAudiencePixelDetailedReport";
export const getAppUrlDetailsEndPoint = baseUrl + "/misc/getAppDetails";
export const getGoogleAuthDetailsEndPoint =
  baseUrl + "/misc/getAccessRefreshTokensAndUserDetails";

export const getPublisherResponseDataEndPoint =
  baseUrl + "/direct/getPublisherResponseData";

export const getBidderResponseDataEndPoint =
  baseUrl + "/direct/getBidderResponseData";

export const getBidderPubRevShareDataEndPoint =
  baseUrl + "/misc/getBidderPubRevShareInfo";

export const updateBidderPubRevShareDataEndPoint =
  baseUrl + "/misc/updateBidderPubRevShareInfo";

export const getBidderWrapUpDataEndPoint =
  baseUrl + "/report/getBidderWrapUpReportData";

export const getBidsDashboardDataEndPoint =
  baseUrl + "/dashboard/getBidsDashboardData";

export const getDashboardPreInfoDataEndPoint =
  baseUrl + "/dashboard/getDashboardPreInfo";

export const getAvailsDashboardDataEndPoint =
  baseUrl + "/dashboard/getAvailsDashboardData";

export const createUpdateAudiencePixelEndPoint =
  baseUrl + "/admin/addAudiencePixelCustomSegment";

export const deleteAudiencePixelEndPoint =
  baseUrl + "/admin/deleteAudiencePixelCustomSegment";

/**
 * MN Pixel Manager, reached through consent_ui_api.
 *
 * The pixel definition is never stored here — everything below is read live
 * from the stored numeric site_id, so a pixel created years ago resolves the
 * same way as one created today.
 */
export const mnPixelCatalogEndPoint = baseUrl + "/apiv2/pixel/catalog";
export const mnPixelDetailEndPoint = (siteId) =>
  `${baseUrl}/apiv2/pixel/${encodeURIComponent(siteId)}`;
export const mnPixelActivityRefreshEndPoint = (siteId) =>
  `${baseUrl}/apiv2/pixel/${encodeURIComponent(siteId)}/activity/refresh`;
export const mnPixelServerSideEndPoint = (siteId) =>
  `${baseUrl}/apiv2/pixel/${encodeURIComponent(siteId)}/server-side`;
export const mnPixelRepublishEndPoint = (siteId) =>
  `${baseUrl}/apiv2/pixel/${encodeURIComponent(siteId)}/republish`;
export const mnPixelDownloadEndPoint = (siteId, artifact) =>
  `${baseUrl}/apiv2/pixel/${encodeURIComponent(siteId)}/download/${artifact}`;

export const getCampaignBidPriceDataEndPoint =
  baseUrl + "/misc/getCampaignBidPriceInfo";

export const updateCampaignBidPriceDataEndPoint =
  baseUrl + "/misc/updateCampaignBidPriceInfo";

export const setCampaignBannerTargetingDataEndPoint =
  baseUrl + "/misc/setCampaignBannerTargeting";

export const getSegmentGeoHashInfoApiUrl =
  baseUrl + "/misc/getSegmentGeoHashesInfo";

export const getPresignedURL = baseUrl + "/misc/getPresignedURL";
export const deleteS3ObjectsURL = baseUrl + "/misc/deleteS3Objects";
export const listAudiencePixelCrmSetsURL =
  baseUrl + "/misc/listAudiencePixelCrmSets";
